import type { Type as GQLItem } from '../../../generated/internal.graphql';
import { take } from '../../../util/takePayload';

/**
 * An event type — the coarsest level of the genre taxonomy — as the superadmin genre screens read
 * and write it on the internal (VP staff) schema.
 *
 * Replaces the AppSchema-backed `src/api/App/Genre/Type.ts` for the staff screens only. That module
 * stays: the tenant-facing announce form still maps the same object out of an event's
 * `announceDetail`, which ADR-009 left on AppSchema.
 */

export type Type = {
  id: string;
  name: string;
};

export const fromGql = (item: GQLItem): Type => take<Type>(item, 'id', 'name');
